import React, { useEffect, useState } from "react";
import { VideoSDKMeeting } from "@videosdk.live/rtc-js-prebuilt";
import { useParams } from "react-router-dom";

export default function JoinsAsGuest() {
  document.title = "Kago Events | Live Session";
  const obj = JSON.parse(localStorage.getItem("authEventKagoUser"));
  const userId = obj?.data?.data?.id;
  const firstName = obj?.data?.data?.firstName;
  const lastName = obj?.data?.data?.lastName;
  const params = useParams();
  const sessionID = params.sessionID;
  const eventID = params.eventID;
  const eventName = params.eventName;
  const sessionName = params.sessionName;
  const mySessionName = sessionName.replace(/-/g, " ");
  const userFullName = `${firstName} ${lastName}`;
  const exitLink = `https://events.kago.digital/${eventName}/conference/${eventID}`;
  // console.log("exitLink...", exitLink);
  console.log("...userId...", userId);

  useEffect(() => {
    const apiKey = "b6d0b019-fd1d-4773-ae33-547dd07381d6";
    // const apiKey = process.env.REACT_APP_VIDEOSDK_API_KEY;
    const meetingId = `${sessionID}`;
    const name = `Click Join Now To Access Session`;
    const config = {
      name: name,
      meetingId: meetingId,
      apiKey: apiKey,
      region: "sg001", // region for new meeting
      participantId: userId,
      theme: "LIGHT",
      //   containerId: null,
      redirectOnLeave: `${exitLink}`,
      micEnabled: false,
      webcamEnabled: false,
      participantCanToggleSelfWebcam: true,
      participantCanToggleSelfMic: true,
      participantCanLeave: true,

      chatEnabled: true,
      screenShareEnabled: false,
      pollEnabled: true,
      whiteboardEnabled: true,
      raiseHandEnabled: true,

      recording: {
        autoStart: false, // auto start recording on participant joined
        enabled: true,
        webhookUrl: "https://www.videosdk.live/callback",
        awsDirPath: `/meeting-recordings/sessions/${meetingId}`, // automatically save recording in this s3 path
      },

      livestream: {
        autoStart: true,
        enabled: true,
      },

      layout: {
        type: "SPOTLIGHT", // "SPOTLIGHT" | "SIDEBAR" | "GRID"
        priority: "SPEAKER", // "SPEAKER" | "PIN",
        // gridSize: 3,
      },

      branding: {
        enabled: false,
        logoURL: null,
        name: mySessionName,
        poweredBy: false,
      },

      permissions: {
        pin: true,
        askToJoin: true, // Ask joined participants for entry in meeting
        canCreatePoll: true,
        toggleParticipantMic: false, // Can toggle other participant's mic
        toggleParticipantWebcam: false, // Can toggle other participant's webcam
        drawOnWhiteboard: false, // Can draw on whiteboard
        toggleWhiteboard: false, // Can toggle whiteboard
        toggleRecording: false, // Can toggle meeting recording
        toggleLivestream: false, //can toggle live stream
        removeParticipant: false, // Can remove participant
        endMeeting: false, // Can end meeting
        changeLayout: true, //can change layout
      },

      joinScreen: {
        visible: true, // Show the join screen ?
        title: mySessionName, // Meeting title
        // meetingUrl: window.location.href, // Meeting joining url
      },

      leftScreen: {
        // visible when redirect on leave not provieded
        actionButton: {
          // optional action button
          label: `${sessionName}`, // action button label
          href: `${exitLink}`, // action button href
        },
      },

      notificationSoundEnabled: true,

      debug: false, // pop up error during invalid config or netwrok error

      maxResolution: "hd", // "hd" or "sd"

      mode: "CONFERENCE",

      //session set time
      autoCloseConfig: {
        type: "session-end-and-deactivate",
        duration: 1,
      },
    };

    const meeting = new VideoSDKMeeting();
    meeting.init(config);
  }, []);

  return <div></div>;
}
